import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const CabecaFixa = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
    @media (max-width: 850px) {
        padding: 0;
    }
`;

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    height: fit-content;
    padding: 8px;

    .accept {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceText400}; 
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 24px;

        p {
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 24px;
        }

        span {
            font-weight: 400;
        }

        > div {
            width: 100%;
        }
    }
`;

export const ModalTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .points {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 18px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.interfaceText400};
        flex: 1;
        padding-right: 16px;
        line-height: 28px;
    }

    .close {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all .2s;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        min-width: 32px;
        &:hover {
            transform: scale(1.3);
        }
        svg {
            width: 20px;
            height: 20px;
            path {
                fill: ${({ theme }) => theme.colors.interfacePure400};
            }
        }
    }
`;

export const ModalButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    justify-content: space-between;
    width: 100%;

    .continue {
        background: ${({ theme }) => theme.colors.primaryRed400};
    }

    .danger {
        background: ${({ theme }) => theme.colors.primaryRed400};
    }
`;